import React, { useEffect, useState } from 'react';
import { API_URL } from '../../config';
import { authFetch } from '../../utils';
import UTM from 'utm-latlng';
import LocationForm from './LocationForm';

export default function LocationList({ onEdit }) {
  const [locations, setLocations] = useState([]);
  const [searchId, setSearchId] = useState('');
  const [editingLocationId, setEditingLocationId] = useState(null);
  const [showCreateForm, setShowCreateForm] = useState(false);

  useEffect(() => {
    authFetch(  `${API_URL}locations`)
      .then(res => res.json())
      .then(setLocations);
  }, []);

  const handleDelete = async (name) => {
    await authFetch(`${API_URL}location/${name}`, { method: 'DELETE' });
    setLocations(locations.filter(loc => loc.name !== name));
  };

  const filteredLocations = locations.filter(loc =>
    loc.detectorId?.toLowerCase().includes(searchId.toLowerCase()) ||
    loc.name?.toLowerCase().includes(searchId.toLowerCase()) ||
    loc.longName?.toLowerCase().includes(searchId.toLowerCase()) ||
    loc.utmx?.toLowerCase().includes(searchId.toLowerCase()) ||
    loc.utmy?.toLowerCase().includes(searchId.toLowerCase())
  );

  const utm = new UTM();

  return (
  <div style={{ maxWidth: '800px', margin: '0 auto', padding: '1rem' }}>
    <h2 style={{ fontSize: '1.8rem', marginBottom: '1rem', textAlign: 'center' }}>
      📍 Ubicaciones
    </h2>

    <button
      onClick={() => setShowCreateForm(true)}
      style={{ backgroundColor: '#28a745', color: '#fff', border: 'none', padding: '0.5rem 1rem', borderRadius: '4px', cursor: 'pointer', marginBottom: '1rem' }}
    >
      ➕ Nueva ubicación
    </button>

    {showCreateForm && (
      <LocationForm
        location={null}
        onSave={() => {
          authFetch(`${API_URL}locations`).then(r => r.json()).then(setLocations);
          setShowCreateForm(false);
        }}
        onCancel={() => setShowCreateForm(false)}
      />
    )}

    <input
      type="text"
      value={searchId}
      onChange={e => setSearchId(e.target.value)}
      placeholder="Buscar por nombre, ubicación o coordenadas..."
      style={{
        width: '100%',
        padding: '0.75rem',
        fontSize: '1rem',
        marginBottom: '1.5rem',
        borderRadius: '6px',
        border: '1px solid #ccc'
      }}
    />

    <ul style={{ listStyle: 'none', padding: 0 }}>
      {filteredLocations.map(loc => {
        const utmCoordinates = utm.convertLatLngToUtm(loc.latitude, loc.longitude, 0);

        return (
          <li
            key={loc._id}
            style={{
              backgroundColor: '#f9f9f9',
              border: '1px solid #ddd',
              borderRadius: '8px',
              padding: '1rem',
              marginBottom: '1rem',
              boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
            }}
          >
            {editingLocationId === loc._id ? (
              <LocationForm
                location={loc}
                onSave={(updated) => {
                  authFetch(`${API_URL}locations`)
                    .then(res => res.json())
                    .then(setLocations);
                  setEditingLocationId(null);
                }}
                onCancel={() => setEditingLocationId(null)}
              />
            ) : (
              <>
                <div style={{ marginBottom: '0.5rem' }}>
                  <strong>Nombre:</strong> {loc.name}
                </div>
                <div><strong>Nombre largo:</strong> {loc.longName || '—'}</div>
                <div><strong>Latitud:</strong> {loc.latitude}</div>
                <div><strong>Longitud:</strong> {loc.longitude}</div>
                <div><strong>UTM x:</strong> {utmCoordinates.Easting}</div>
                <div><strong>UTM y:</strong> {utmCoordinates.Northing}</div>

                <div style={{ marginTop: '1rem' }}>
                  <button
                    onClick={() => setEditingLocationId(loc._id)}
                    style={{
                      marginRight: '0.5rem',
                      padding: '0.5rem 1rem',
                      backgroundColor: '#007bff',
                      color: '#fff',
                      border: 'none',
                      borderRadius: '4px',
                      cursor: 'pointer'
                    }}
                  >
                    Editar
                  </button>
                  <button
                    onClick={() => {
                      const confirmDelete = window.confirm(`¿Eliminar la ubicación "${loc.name}"?`);
                      if (confirmDelete) handleDelete(loc.name);
                    }}
                    style={{
                      padding: '0.5rem 1rem',
                      backgroundColor: '#dc3545',
                      color: '#fff',
                      border: 'none',
                      borderRadius: '4px',
                      cursor: 'pointer'
                    }}
                  >
                    Eliminar
                  </button>
                </div>
              </>
            )}
          </li>
        );
      })}
    </ul>
  </div>
);

}
